import { memo } from "react";
import { LoginLayout } from "../layout/LoginLayout"

export const Home = memo(() => {
  return (
  <LoginLayout>
    <p>Homeページです</p>
  </LoginLayout>
  );
});